module.exports = __webpack_public_path__ + "static/badge_new-fb2b559d6f61a07c29cb60ac10393620.gif";